import { Dispatcher, getProxyDispatcher, getProxyTarget, IDispatcherEventMap, IStoreWithData, requestStaticData, storeUtils, toProxy, watchProperty } from "@fanfanlo"
import { IVisit, IVisitAppStartParams, tmsVisitAppStart,  } from "../remote/visit"
import {tmsGetUserInfo} from "../remote/user";
import { ulid } from "ulid"
import _ from "lodash"
import { ITableGlobalRegisteredUser, ITablePrimeAppUser } from "../tables";
import { IIMAppUserData } from "./IMUserData";

const ns = 'user'

interface IUserStoreData{
    user_token?:string
    device_info_uuid?:string
    device_id:string
    browser_id?:string
    client_user_uuid?:string
}
interface IUserSessionData{
    visit?:IVisit
    global_user_info?:ITableGlobalRegisteredUser
    prime_user_info?:ITablePrimeAppUser
}
export interface IUserDataShell {
    userInitialized:boolean
    storeData:IUserStoreData
    sessionData:IUserSessionData
    imAppUserData?:IIMAppUserData
}
function createDefaultStoreData(){
    return {
        user_token:undefined,
        device_info_uuid:undefined,
        device_id:ulid(),
        browser_id:undefined,
        client_user_uuid:undefined
    }
}
function createDefaultUserData():IUserDataShell{
    return {
        userInitialized:false,
        storeData:createDefaultStoreData(),
        sessionData:{
            visit:undefined
        },
        imAppUserData:undefined
    }
}

let store:IStoreWithData<IUserStoreData>

export interface IUserEventMap extends IDispatcherEventMap{
    onUserTokenChange:(now?:string, old?:string)=>void
    onUserSignin:()=>void
    onUserSignout:()=>void
    onUserInitialized:()=>void
    onUserChanged:()=>void
}
function watchUserTokenChange(){
    watchProperty(getProxyDispatcher(user.data.storeData), 'user_token', (now, old)=>{
        // console.log('user_token changed', now, old);
        user.dispatch<IUserEventMap>('onUserTokenChange', now, old)
        if(now){
            user.dispatch<IUserEventMap>('onUserSignin')
        }else{
            user.dispatch<IUserEventMap>('onUserSignout')
        }
        // 防止后续有属性继续变更，这里做成微任务使其排队到帧末执行。
        Promise.resolve().then(()=>{
            user.dispatch<IUserEventMap>('onUserChanged')
        });
    })
}

function checkStoreData(storeData:IUserStoreData){
    if(!storeData.device_id){
        storeData.device_id = ulid();
    }
}
class User extends Dispatcher{
    data = toProxy(createDefaultUserData())
    constructor(){
        super()
    }
    async init(){
        store = await storeUtils.getNamespaceStoreWithData(ns, {forceReset:false, mergeDefData:false, defData:createDefaultStoreData()});
        this.data.storeData = store.data;
        checkStoreData(this.data.storeData)
        
        this.listen();
        const params:IVisitAppStartParams = {
            device_id:this.data.storeData.device_id,
            browser_id:this.data.storeData.browser_id || ulid(),
            user_token:this.data.storeData.user_token,
            client_user_uuid:this.data.storeData.client_user_uuid,
            device_info_uuid:this.data.storeData.device_info_uuid,
        }
        requestStaticData.userToken = this.data.storeData.user_token;
        requestStaticData.deviceToken = this.data.storeData.device_id;
        const res = await tmsVisitAppStart({params, handler:{printLog:false}})
        if(res.data){
            const visit = res.data.visit;
            this.data.sessionData.visit = visit;
            if(visit.device_info_uuid){
                this.data.storeData.device_info_uuid = visit.device_info_uuid;
            }
            if(res.data.global_user_info){
                this.data.sessionData.global_user_info = res.data.global_user_info;
            }
            if(res.data.app_user_info){
                this.data.sessionData.prime_user_info = res.data.app_user_info;
            }
        }
        this.data.imAppUserData = {
            // homeserverUrl:res.data.visit.im_matrix_url,
            homeserverUrl:'https://website-droid-dev.droidlego.com',
        }
        this.data.userInitialized = true;
        this.dispatch<IUserEventMap>('onUserInitialized')
        this.dispatch<IUserEventMap>('onUserChanged')
    }
    private async listen(){
        watchUserTokenChange();
    }
    async signout(){
        this.data.storeData.user_token = undefined;
    }
    async setUserToken(token:string){
        this.data.storeData.user_token = token;
    }

    get userName(){
        const globalUserInfo = this.data.sessionData?.global_user_info;
        if(!globalUserInfo)return;
        return globalUserInfo.nickname || globalUserInfo.name || globalUserInfo.mobile || globalUserInfo.email;
    }

}
export const user = new User();

// user.addListener<IUserEventMap>('onUserTokenChange', (now, old)=>{
//     console.log('user_token changed', now, old);
// })